import React, { useState } from "react";
import IconLink from "./IconLink";
import { Box } from "@mui/material";
import Chip from "@mui/material/Chip";
import "./ProtfolioBlockModule.scss";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function PortfolioBlock(props) {
  const {
    live,
    source,
    title,
    imagesUrl,
    id,
    summery,
    usedModules,
    technologies,
  } = props;
  const [loadImages, setLoadImages] = useState(imagesUrl[0] ?? "");
  const [exp, setExp] = useState(false);
  const [clicked,setClicked] = useState(0)

  const chipsColors = [
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ];

  const ImageButtons = () => {
    return (
      <div className="flexcontainer">
        {imagesUrl
          .filter((item) => !!item)
          .map((item, index) => (
            <Chip
              key={index}
              size="small"
              style={{
                border: "none",
                margin: "1px",
                fontSize: "10px",
              }}
              label={index + 1}
              color={index === clicked ? "error" : "primary"}
              onClick={() => {
                setClicked(index);
                setLoadImages(item);
              }}
            />
          ))}
      </div>
    );
  };

  const SourceCodeAndLiveDemo = () => {
    return (
      <Box
        className={"portfolio"}
        display={"flex"}
        flexDirection={"column"}
        gap={"0.5rem"}
        alignItems={"align"}
        fontSize={"1.5rem"}
        py={"0rem"}
      >
        {live && source !== null ? (
          <Box p={0}>
               <IconLink color="blue" link={live} title={"Check the Web site"} icon={"fa fa-chrome"} />
          </Box>
        ) : (
          ""
        )}
        {source !== "" && source !== null ? (
          <Box p={1} >
            <IconLink color="blue" link={source} title={"Check the code"} icon={"fa fa-code blue"} />
          </Box>
        ) : (
          ""
        )}
      </Box>
    );
  };
  function SimpleAccordion() {
    return (
      <Accordion
        sx={{ width: 1 }}
        onChange={(e, expanded) => {
          setExp(!exp);
        }}
        expanded={exp}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              style={{
                color: "black",
                border: "1px solid black",
                borderRadius: "100%",
              }}
            />
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <h1
            style={{
              fontSize: "1rem",
              height: "40px",
            }}
          >
            {id + 1} {` : `} {title}
          </h1>
        </AccordionSummary>
        <AccordionDetails>
          <Technologies />
          <div
            style={{
              paddingBottom: "1%",
              fontSize: "15px",
              margin: "5px 0 0 5px",
            }}
            dangerouslySetInnerHTML={{
              __html: (summery ?? "")
                .replaceAll(
                  "<li>",
                  `<li style="color:black;margin:5px 5px 0 0;" >`
                )
                .replaceAll("<ul>", `<ul style="list-style-type:disc;" >`),
            }}
          />
          {/* <h2 style={{ paddingBottom: "1%", fontSize: "15px" }}>{summery}</h2> */}
          <UsedModules />
          <SourceCodeAndLiveDemo />
          {loadImages && (
            <>
              <Box
                sx={{ height: "300px", width: 1, backgroundColor: "white" }}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box
                  component={loadImages.includes(".mp4") ? "video" : "img"}
                  src={loadImages}
                  alt={loadImages}
                  sx={{
                    height: "300px",
                    width: "100%",
                    borderRadius: "10px",
                    margin: "2px 2px",
                    objectFit: "fill",
                  }}
                  lazy={!loadImages.includes(".mp4") ?? "lazy"}
                  autoPlay={loadImages.includes(".mp4")}
                  controls={loadImages.includes(".mp4")}
                />
              </Box>
            </>
          )}
          <>
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"left"}
              alignItems={"left"}
              style={{ padding: "1%" }}
            >
              <ImageButtons />
            </Box>
          </>
        </AccordionDetails>
      </Accordion>
    );
  }
  const Technologies = () => {
    return (
      <Box sx={{ width: 1 }}>
        {technologies
          .filter((item) => item !== "" && item !== null)
          .map((item, index) => (
            <Chip
              sx={{ margin: "2px", height: "25px", fontSize: "8" }}
              key={index}
              label={item}
              color={chipsColors[index % chipsColors.length]}
              onClick={() => {}}
            />
          ))}
      </Box>
    );
  };

  const UsedModules = () => {
    return (
      // <Stack direction="row" spacing={1} style={{ paddingTop: '1%' }}>
      <Box sx={{ width: 1 }}>
        {usedModules
          .filter((item) => item !== "" && item !== null)
          .map((item, index) => (
            <Chip
              key={index}
              label={item}
              color={chipsColors[index % chipsColors.length]}
              onClick={() => {}}
              sx={{ margin: "2px", height: "25px", fontSize: "8" }}
            />
          ))}
      </Box>
      //</Stack>
    );
  };
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      style={{ padding: "10px" }}
    >
      <SimpleAccordion />
    </Box>
  );
}

export default PortfolioBlock;
